import { downLoadFile } from '@utils'
import { getPlanPdfFileName } from './utils'

/**
 * Saves a plan's PDF as a file. The signed url is cross-origin, where `<a download>` is ignored,
 * so the PDF is fetched as a blob first (same approach as the Pläne page's duplicate action). The
 * file name carries the project name, like the old Pläne page's download.
 */
const downloadPlanPdf = async (plan: Plan, projectName?: string): Promise<void> => {
  if (!plan.url) throw new Error('Plan has no download url')

  const response = await fetch(plan.url)
  if (!response.ok) throw new Error('Plan download failed')

  downLoadFile(await response.blob(), 'application/pdf', getPlanPdfFileName(plan, projectName))
}

export default downloadPlanPdf
